import { dbRefsWithRelationshipKeys, DbRef } from '@caresend/types';
import { useDbSyncStore } from '../dbSync/dbSyncStore.js';

const isDbSyncMeta = (meta) => !!meta && Object.hasOwnProperty.call(meta, 'pathGetter');
const isDbRef = (context) => Object.values(DbRef).includes(context);
const isRelationshipRef = (context) => Object.keys(dbRefsWithRelationshipKeys).includes(context);
/**
 * Queue a record to be synced with the database.
 *
 * @param id - The id of the record.
 * @param item - The item to sync to the database.
 * @param path - The path to the value to set.
 * @param entityLabel - The label of the entity.
 * @param context - The context to sync the record to.
 * @param writeLabel - The label of the write.
 * @param diffs - Changes tracked to analyze the validity
 * of incoming data.
 */
const dbSync = (id, item, path, entityLabel, context, writeLabel = false, diffs = {}) => {
    let label;
    if (!isDbRef(context))
        return;
    if (typeof writeLabel === 'string') {
        label = writeLabel;
    }
    else {
        label = `set ${entityLabel} ${id.substring(0, 5)}...`;
    }
    useDbSyncStore().queueNextUpdate(path, label, item, context, diffs);
};

export { dbSync, isDbRef, isDbSyncMeta, isRelationshipRef };
